<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <!-- Avatar -->
                    <div
                      class="md-layout-item md-size-100 md-xsmall-size-100"
                      id="board-member-avatar"
                    >
                      <h4 class="card-title">
                        {{ $t("board_member.avatar") }}
                      </h4>
                      <div class="file-input img-circle">
                        <template v-if="!imageCircle">
                          <div class="image-fix-container">
                            <img :src="avatarImg" title="" alt="" />
                          </div>
                        </template>
                        <div class="image-fix-container" v-else>
                          <img :src="imageCircle" alt="" />
                        </div>
                        <div class="button-container">
                          <md-button
                            class="md-success md-round md-fileinput"
                            @click="onFileChange"
                          >
                            <template v-if="!imageCircle"
                              >{{ $t("board_member.add_avatar") }}
                            </template>
                            <template v-else
                              >{{ $t("board_member.change_avatar") }}
                            </template>
                          </md-button>
                        </div>
                      </div>
                    </div>

                    <!-- Left  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--   name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('board_member.name')"
                            >
                              {{ $t("board_member.name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('board_member.name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input v-model="params.name" type="text">
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   Order number    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('board_member.order_number')"
                            >
                              {{ $t("board_member.order_number") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('board_member.order_number')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.order_number"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Right  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--   Description    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('board_member.description')"
                            >
                              {{ $t("board_member.description") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('board_member.description')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-textarea v-model="params.description">
                                  </md-textarea>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <!--  Avatar  -->
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
      :auto-crop-area="1"
    ></crop-upload-image-modal>
  </div>
</template>

<script>
import sanitizer from "sanitizer";
import { BoardMemberService } from "../../../services/boardMember.service";
import queryHelper from "@/helpers/query-helper";
import CropUploadImageModal from "../../../components/VueUploadMultipleImage/CropUploadImageModal";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
export default {
  name: "BoardMemberCreateForm",
  components: { CropUploadImageModal },
  props: {
    id: {},
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formTitle: this.$t("page_title.news_create"),
      defaultAvatarFile: null,
      avatarFile: null,
      editor: DecoupledEditor,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      },
      avatarImg: "../img/image_placeholder.jpg",
      modalAvatar: {
        show: false,
        action: "create"
      },
      imageCircle: "",
      params: {
        name: null,
        description: null,
        avatar: null,
        order_number: null
      }
    };
  },
  watch: {
    id(newVal) {
      this.getDetailBoardMember(newVal);
    }
  },
  mounted() {
    if (this.editMode) {
      this.getDetailBoardMember(this.id);
    }
  },
  methods: {
    async getDetailBoardMember(id) {
      const info = await new BoardMemberService().getById(id);
      this.params.name = info.name;
      this.params.description = info.description;
      this.params.order_number = info.order_number;
      this.params.avatar = info.avatar;

      //  get avatar image
      if (info.avatar !== null && info.avatar !== "") {
        this.imageCircle = info.avatar;
      }
    },
    changeFile(name, files) {
      if (name === "avatar") {
        this.avatarFile = files[0];
      }
    },
    cancel() {
      this.$router.push({ name: "BoardMemberList" });
    },
    async submit() {
      let formData = this.buildFormDataCreateBoardMember();
      if (this.editMode) {
        await this.updateBoardMember(this.id, formData);
        return;
      }
      await this.createBoardMember(formData);
    },
    async createBoardMember(formData) {
      const response = await new BoardMemberService().create(formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("board_member.name"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "BoardMemberList" }), 500);
    },
    async updateBoardMember(id, formData) {
      const response = await new BoardMemberService().update(id, formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          name: this.$t("board_member.name"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    buildFormDataCreateBoardMember() {
      let params = this.params;
      if (this.editMode) {
        params._method = "PUT";
      }
      return queryHelper.buildFormData(params);
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.params.avatar = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style scoped lang="scss">
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.image-fix-container {
  max-width: 250px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px -12px rgb(0 0 0 / 42%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
}

.content-button {
  margin: 0;
}

.management-uni-rating-container {
  text-align: right;
  margin: 10px 40px;
}

.management-uni-rating-container a {
  display: inline-block;
  text-align: center;
}

.management-uni-rating-container a:hover {
  cursor: pointer;
}

.management-uni-rating-container a i {
  padding: 10px;
  font-size: 16px;
  background: #9c27b0;
  border-radius: 10px;
}

.management-uni-rating-container a i.fa-pen:before {
  color: #ffffff;
}

.edit-btn {
  background: #9c27b0;
  color: #ffffff !important;
  font-size: 18px;
  border-radius: 8px;
  padding: 10px 10px;
  font-weight: 500;
}

#uni-avatar {
  margin-bottom: 30px;
}

.uni-count-container {
  h4 {
    margin: 10px 0 0;
    max-width: 320px;
    background: #4caf50;
    border-radius: 2px;
    padding: 5px;
    color: #ffffff;
    font-weight: 500;
    text-align: center;
  }
}

#uni-cover {
  margin-bottom: 30px;
  .file-input.img-circle {
    max-width: 250px;
  }
  .image-fix-container {
    max-width: 250px;
  }
}

#board-member-avatar {
  margin-bottom: 30px;
  .file-input.img-circle {
    max-width: 250px;
  }
  .image-fix-container {
    max-width: 250px;
  }
}
</style>
